const config = {
    env:window._env_.ENV,
    apiURL: window._env_.API_URL,
    documentURL: window._env_.DOCVAULT_URL,
    refundRequestMessage: window._env_.REFUNDREQURESTMESSAGE
};

const CONFIG = config;

export default CONFIG;